import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/home/HeroSection';
import BrandsSection from '../components/home/BrandsSection';
import YourstorySection from '../components/home/YourstorySection';
import BlogSection from '../components/home/BlogSection';
import { AdminEditToggle } from '../components/admin/InlineEditor';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <BrandsSection />
        <YourstorySection />
        <BlogSection />
      </main>
      <Footer />
      <AdminEditToggle />
    </div>
  );
};

export default HomePage;
